function escapeCell(value) {
  if (value === null || value === undefined) return '';
  let str;
  if (Array.isArray(value)) {
    str = value
      .map((el) => (el && typeof el === 'object' ? el.url : el))
      .filter((v) => v !== null && v !== undefined && v !== '')
      .join(';');
  } else {
    str = String(value);
  }
  if (/[",\n\r]/.test(str)) {
    return '"' + str.replace(/"/g, '""') + '"';
  }
  return str;
}

export function toCsv(items) {
  if (!Array.isArray(items) || items.length === 0) return '';
  const headers = Object.keys(items[0]);
  const headerRow = headers.map(escapeCell).join(',');
  const rows = items.map((item) =>
    headers.map((h) => escapeCell(item[h])).join(',')
  );
  return '﻿' + [headerRow, ...rows].join('\r\n');
}

// 다운로드 CSV용: 댓글 배열을 한 셀에 들어갈 여러 줄 문자열로 변환
export function formatCommentsForCsv(comments) {
  if (!Array.isArray(comments) || comments.length === 0) return '';
  return comments
    .map((c, i) => {
      const name = c.commenter_name || '익명';
      const text = String(c.comment_text || '').replace(/[\r\n]+/g, ' ');
      return `${i + 1}. ${name}: ${text} (♥${c.num_likes || 0})`;
    })
    .join('\n');
}
